import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { AccessGuard } from './guards/access.guard';
import { ForbiddenComponent } from './pages/forbidden/forbidden.component';
import { AuthComponent } from './pages/auth/auth.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { AboutCompanyComponent } from './pages/about-company/about-company.component';
import { ServicesComponent } from './pages/services/services.component';
import { SecurityDealComponent } from './pages/security-deal/security-deal.component';

export const routes: Routes = [
  {
    path: 'cabinet',
    loadChildren: (): Promise<any> => import('./module/cabinet/cabinet.module').then((m) => m.CabinetModule),
    canActivate: [AccessGuard],
  },
  {
    path: 'forbidden',
    component: ForbiddenComponent,
  },
  {
    path: 'auth',
    component: AuthComponent,
  },
  {
    path: 'o-kompanii',
    component: AboutCompanyComponent,
  },
  {
    path: 'services',
    component: ServicesComponent,
  },
  {
    path: 'services/security',
    component: SecurityDealComponent,
  },
  {
    path: 'novosti',
    loadChildren: (): Promise<any> => import('./module/news/news.module').then((m) => m.NewsModule),
  },
  {
    path: '',
    loadChildren: (): Promise<any> => import('./module/catalog/catalog.module').then((m) => m.CatalogModule),
  },
  {
    path: '**',
    component: NotFoundComponent,
  },
];

@NgModule({
  providers: [],
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'top',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
